import axios from 'axios'
import HTTP from '@rocketfid/api'

const state = {
  items: []
}

// getters
const getters = {
  contests: (state) => {
    return state.items
  },
  getById: (state) => (id) => {
    return state.items.find(item => item.id === id)
  }
}

// actions
const actions = {
  loadContests ({ commit, dispatch, rootGetters }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .contest.getAll()
      .then((contests) => {
        dispatch('contest/resetContests', null, { root: true })
        commit('ADD_CONTEST_ITEMS', { items: contests })
        return contests
      })
  },

  loadContest ({ commit, rootGetters }, { id }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .contest.get(id)
      .then((contest) => {
        commit('UPDATE_CONTEST_ITEM', { item: contest })
        return contest
      })
  },

  resetContests ({ commit }) {
    return new Promise((resolve) => {
      commit('RESET_CONTEST_ITEMS')
      resolve()
    })
  },

  addContest ({ commit, rootGetters }, { contest }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .contest.create(contest)
      .then((contest) => {
        commit('ADD_CONTEST_ITEM', { item: contest })
        return contest
      })
  },

  updateContest ({ commit, rootGetters }, { contest }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .contest.update(contest)
      .then((contest) => {
        commit('UPDATE_CONTEST_ITEM', { item: contest })
        return contest
      })
  },

  removeContest ({ commit, rootGetters }, { contest }) {
    let sitekey = rootGetters['account/currentSitekey']

    return HTTP
      .setInstance(sitekey)
      .contest.delete(contest)
      .then((contest) => {
        commit('REMOVE_CONTEST_ITEM', { item: contest })
        return contest
      })
  },

  getContestRank ({ commit, dispatch }, { contest, sitekey }) {
    return new Promise((resolve, reject) => {
      const pagination = 25
      let users = []
      let _load = function (page, contest, resolve, reject) {
        let url = process.env.API + '/contest/' + contest.id + '/rank/' + page + '/' + pagination + '/'

        axios.get(url, { headers: { 'X-Instance': sitekey } })
          .then(response => {
            // add sitekey to element
            response.data.map(function (element) {
              element.sitekey = sitekey
              return element
            })

            users.push(...response.data)

            if (response.data.length === pagination) {
              page++
              _load(page, contest, resolve, reject)
            } else {
              resolve(users)
            }
          })
          .catch(e => {
            reject(e)
          })
      }

      _load(0, contest, resolve, reject)
    })
  },

  getContestRankByPage ({ commit, rootGetters }, { id, page }) {
    let sitekey = rootGetters['account/currentSitekey']

    return new Promise((resolve, reject) => {
      let url = process.env.API + '/contest/' + id + '/rank/' + page + '/' + 24 + '/'

      axios.get(url, { headers: { 'X-Instance': sitekey } })
        .then(response => {
          resolve(response.data)
        })
        .catch(e => {
          reject(e)
        })
    })
  }
}

// mutations
const mutations = {
  ADD_CONTEST_ITEMS: (state, { items }) => {
    state.items.push(...items)
  },

  RESET_CONTEST_ITEMS: (state) => {
    state.items = []
  },

  ADD_CONTEST_ITEM: (state, { item }) => {
    state.items.push(item)
  },
  UPDATE_CONTEST_ITEM: (state, { item }) => {
    let find = false

    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        Object.assign(state.items[i], item)
        find = true
      }
    }

    if (!find) {
      state.items.push(item)
    }
  },
  REMOVE_CONTEST_ITEM: (state, { item }) => {
    for (let i = 0; i < state.items.length; i++) {
      if (state.items[i].id === item.id) {
        return state.items.splice(i, 1)
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/contest.js